import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import './style.css'
import App from './App.vue'
import router from './router'
import { preloadCultureIcons } from '@/services/cardService'
import { vTooltip } from '@/directives/tooltip'
import { initTheme } from '@/composables/useTheme'

initTheme()

const app = createApp(App)

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: 'https://5bafcb4a799e339176472fe5a7e9e44b@o4511219456081920.ingest.us.sentry.io/4511219463618560',
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    tracesSampleRate: 0.1,
  })
}

app.use(createPinia())
app.use(router)
app.directive('tooltip', vTooltip)
app.mount('#app')

preloadCultureIcons()

document.addEventListener('contextmenu', (e) => {
  const target = e.target as HTMLElement
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return
  e.preventDefault()
})
